(function($) {

    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,


        splitText : {},


        banner: function(){

            var timeline = new TimelineMax();


            if (__.global.screen === "large") {
                __.splitText.banner_title =  __.global.splitText($( '.pg-work-carousel--slide--title' ));
                __.splitText.banner_text =  __.global.splitText($( '.pg-work-carousel--slide--text' ));

                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right), '+=1')
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up))

                .add(TweenMax.from('.pg-work-carousel--container', 0.4,  { opacity: 0 }) )
                .add(TweenMax.from('.pg-work-carousel--slide--image-container', 0.4, __.global.animations.fade.right))

                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) )


                .add(TweenMax.from('.pg-work-carousel--slide--content', 0.4, __.global.animations.fade.right), '-=0.4' );
                __.global.staggerDisplay( __.splitText.banner_title, timeline);
                __.global.staggerDisplay( __.splitText.banner_text, timeline);


                timeline
                .add(TweenMax.from('.pg-work-carousel--slide--link--outer', 0.4, __.global.animations.slide.up) )
                .add(TweenMax.from('.pg-work-carousel--slide--link--line', 0.4, {width: 0} ) )

                .call(function() {
                    __.grid();
                    __.global.completeLoadInAnimation();
                    __.splitText.banner_title.revert();
                    __.splitText.banner_text.revert();
                });
            }else{

                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down))
                .add(TweenMax.from('.pg-work-carousel--slide--content-container', 0.4, __.global.animations.fade.right))
                .add(TweenMax.from('.pg-work-carousel--slide--content', 0.4, __.global.animations.fade.up))
                .call(function() {
                    __.grid();
                    __.global.completeLoadInAnimation();
                });
            }
            timeline.play();
        },
        grid: function(){
            $('.pg-work--posts').addClass('pg-work--display');
        },


        // Function that runs on load
        loadAnimations: function() {
            __.banner();

            window._animations.base.footerAnimations();

        },
        // Function to call to setup functionality
        setup: function() {
            __.loadAnimations();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.work = __;
})(jQuery); // Fully reference jQuery after this point.